var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fraction-data-graph"},[_c('e-chart',{ref:"chart",attrs:{"option":_vm.fractionGraphOptions,"autoresize":true},on:{"legendselectchanged":function($event){return _vm.updateContainerCount($event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }